'use strict';
const BaseView = require('components-framework/view/base.view');

const classNames = {
    tryAgainAction: '.try_again_action',
    cancelAction: '.cancel_action',
};

const trackingUtils = require('od-modules/utils/tracking.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

const trackInfo = {
    action: 'prime_subscription_error',
    label: {
        add: {
            display: 'prime_subscription_error_add',
            tryAgain: 'prime_subscription_error_add_try_again',
            close: 'prime_subscription_error_add_close',
        },
        remove: {
            display: 'prime_subscription_error_remove',
            tryAgain: 'prime_subscription_error_remove_try_again',
            close: 'prime_subscription_error_remove_close',
        },
    },
    category: {
        pax: 'flights_pax_page',
        pay: 'flights_pay_page',
    },
};

module.exports = BaseView.extend({
    renderTemplate(toDelete) {
        this.track = {
            action: trackInfo.action,
            label: toDelete ? trackInfo.label.remove.display : trackInfo.label.add.display,
            category: trackInfo.category[this.options.page],
        };
        this.toDelete = toDelete;
        this.$el.children().remove();
        const action = !toDelete ? 'Add' : 'Remove';
        this.keys = Odigeo._.extend(this.keys, {
            subscriptionErrorHeader: this.keys[`membershipSubscriptionError${action}Header`],
            subscriptionErrorText: this.keys[`membershipSubscriptionError${action}Text`],
            subscriptionErrorSubtext: this.keys[`membershipSubscriptionError${action}Subtext`],
            subscriptionErrorClose: this.keys[`membershipSubscriptionError${action}Close`],
            subscriptionErrorTryAgain: this.keys[`membershipSubscriptionError${action}TryAgain`],
        });
        this.$el.append(this.templates[this.options.template]({
            keys: this.keys,
            selector: this.options.selector,
            containerClass: this.$el.find('.subscription_prime_container').hasClass('open') ? 'isolated' : '',
        }));
        this.trackEvents();
    },
    selectors: {
        tryAgainButton: classNames.tryAgainAction,
        cancelButton: classNames.cancelAction,
    },

    events: {
        ['tap ' + classNames.tryAgainAction]: 'onTapTryAgainButton',
        ['tap ' + classNames.cancelAction]: 'onTapCancelButton',
    },
    onTapTryAgainButton() {
        this.track.label = this.toDelete ? trackInfo.label.remove.tryAgain : trackInfo.label.add.tryAgain;
        Odigeo.trigger(`${this.id}:tryAgain`);
        this.trackEvents();
    },
    onTapCancelButton() {
        this.track.label = this.toDelete ? trackInfo.label.remove.close : trackInfo.label.add.close;
        Odigeo.trigger(`${this.id}:cancel`);
        this.trackEvents();
    },
    trackEvents() {
        const id = '#membership_subscription_error';
        trackFrontEventsUtils.trackJQElementDisplayed(this.$el.find(id));
        trackingUtils.trackEventWithCategory(this.track.category, this.track.action, this.track.label);
    },
});
